// TODO [react-onboarding] - make sure that all of the flow actions are covered
// https://github.com/strava/active/blob/main/app/controllers/onboarding_controller.rb#L11
export const REGISTRATION_FLOW = Object.freeze({
  /** `onboarding/continue` is the entry point since we are leveraging legacy endpoint redirects.
   * We will be able to change this only after we stop depending on the current backend
   * implementation for determining when to redirect athletes back to the onboarding flow.
   *
   * See OnboardingController#continue
   * */
  createProfile: 'continue',
  suggestedFriends: 'suggested_friends',
  facebookFriends: 'facebook_friends',
  welcome: 'welcome_to_strava'
});

export const CONSENTS_FLOW = Object.freeze({
  welcome: 'welcome',
  termsOfService: 'terms_of_service'
});

export const ONBOARDING = 'onboarding';

export const CONSENTS = 'consents';

export const INPUT_IDS = Object.freeze({
  firstName: 'firstName',
  lastName: 'lastName'
});

export default { REGISTRATION_FLOW, CONSENTS_FLOW, ONBOARDING, CONSENTS };
